// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"222":"16c23412","415":"4e2a130c"}[chunkId] + ".css";
};